// extracted by mini-css-extract-plugin
export default {"flex":"reports_flex__p9gVu","header":"reports_header__xsKQR","search_wrapper":"reports_search_wrapper__Tfc1m"};